import { EsAdditionalProduct } from "@edp-models/ES/es-product.model";
import { Action } from "@ngrx/store";

export enum EEsProductActions {
    GetAdditionalProductEs = "[AdditionalProduct] Get Additional Product",
    SetAdditionalProductEs = "[AdditionalProduct] Set Additional Product",
}

export class GetAdditionalProductEs implements Action {
    public readonly type = EEsProductActions.GetAdditionalProductEs;
    constructor(public contractId: string) {}
}

export class SetAdditionalProductEs implements Action {
    public readonly type = EEsProductActions.SetAdditionalProductEs;
    constructor(public payload: EsAdditionalProduct) {}
}

export type EsProductActions = GetAdditionalProductEs | SetAdditionalProductEs;
